import { render, staticRenderFns } from "./DialogViewQuestionSelected.vue?vue&type=template&id=5f388ab8&scoped=true&"
import script from "./DialogViewQuestionSelected.vue?vue&type=script&lang=ts&"
export * from "./DialogViewQuestionSelected.vue?vue&type=script&lang=ts&"
import style0 from "./DialogViewQuestionSelected.vue?vue&type=style&index=0&id=5f388ab8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f388ab8",
  null
  
)

export default component.exports